import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

console.log("ApplicationController");
console.log(StimulusReflex);

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  connect() {
    super.connect();
    console.log(`Connected controller: ${this.identifier}`);
  }

  // Common utility methods for all controllers
  showLoading() {
    this.element.classList.add("opacity-50", "pointer-events-none");
  }

  hideLoading() {
    this.element.classList.remove("opacity-50", "pointer-events-none");
  }

  showError(message) {
    // You might want to use a toast/notification system here
    console.error(message);
  }

  beforeReflex() {
    this.showLoading();
  }

  afterReflex() {
    this.hideLoading();
  }

  reflexError(element, reflex, error) {
    this.hideLoading();
    this.showError(error);
  }

  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  reflexSuccess(element, reflex, noop, reflexId) {
    // show success message
  }

  reflexHalted(element, reflex, error, reflexId) {
    // handle aborted Reflex action
  }

  finalizeReflex(element, reflex, noop, reflexId) {
    // all operations have completed, animation etc is now safe
  }
}
